import { useEffect, useState, useRef } from "react";
import { STATUS } from "@/utils/enum";
import { runPricingEngine } from "@/services/pricingService";

const buildPricingEnginePayload = shipmentData => {
  const { vehicleData } = shipmentData;

  return {
    vehicleType: vehicleData?.vehicleType,
    vehicleGrossWeight: vehicleData?.curbWeight,
    vin: vehicleData?.vin,
    shipmentId: shipmentData?.id,
    distance: shipmentData?.distance,
    vehicleCount: (shipmentData?.vehicles?.length ?? 0) + 1,
    pickupZip: shipmentData?.pickupAddress?.zipCode,
    pickupCity: shipmentData?.pickupAddress?.city,
    pickupStateId: shipmentData?.pickupAddress?.stateId,
    pickupStateShortName: shipmentData?.pickupAddress?.stateShortName,
    dropOffZip: shipmentData?.dropOffAddress?.zipCode,
    dropOffCity: shipmentData?.dropOffAddress?.city,
    dropOffStateId: shipmentData?.dropOffAddress?.stateId,
    dropOffStateShortName: shipmentData?.dropOffAddress?.stateShortName,
    dealerId: shipmentData?.dealerId,
  };
};

export default function usePricingEngine({ shipmentData, onSuccess }) {
  const [status, setStatus] = useState(STATUS.IDLE);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const lastRequestParams = useRef(null);

  useEffect(() => {
    const payload = buildPricingEnginePayload(shipmentData);
    if (!payload?.shipmentId || !payload?.vin) return;

    if (lastRequestParams.current === `${payload?.shipmentId}-${payload?.vin}`) return;

    const fetchPricingEngine = async () => {
      try {
        lastRequestParams.current = `${payload?.shipmentId}-${payload?.vin}`;
        setStatus(STATUS.LOADING);
        setError(null);
        setData(null);

        const response = await runPricingEngine(payload);

        setData(response);
        setStatus(STATUS.SUCCESS);
        onSuccess(response);
      } catch (err) {
        setStatus(STATUS.ERROR);
        setError(err);
        console.error(err);
      }
    };

    fetchPricingEngine();
  }, [shipmentData, onSuccess]);

  return { data, status, error };
}
